import { render, staticRenderFns } from "./QAList.vue?vue&type=template&id=792deef3"
import script from "./QAList.vue?vue&type=script&lang=js"
export * from "./QAList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports